import { HistoryEduOutlined } from "@mui/icons-material";
import { Alert, Stack, Typography } from "@mui/material";
import AcxButton from "components/UI/AcxButton";
import AcxDialog from "components/UI/Dialog/AcxDialog";
import AcxMainTextField from "components/UI/AcxMainTextField";
import moment from "moment";
import {
    contextAlertIconColor,
    contextAlertSx,
} from "../../utils/contextAlert";

export function ReviewApprovalDialog(props: {
    isOpen: boolean;
    onClose: () => void;
    versionLabel: string;
    approverName: string;
    onApproverNameChange: (name: string) => void;
    isSaving: boolean;
    canApprove: boolean;
    onReject: () => void;
    onRequestChanges: () => void;
    onApprove: () => void;
}) {
    return (
        <AcxDialog
            isOpen={props.isOpen}
            onClose={props.onClose}
            title={`Approve ${props.versionLabel}`}
            hideCancelButton
            buttonsDisabled={props.isSaving}
            dialogContentChildren={
                <Stack gap={2.5}>
                    <Typography variant="body2" color="gray.700">
                        Type your name to confirm you reviewed the changes for
                        this version, and that you are not its author.
                    </Typography>
                    <Stack direction={{ xs: "column", sm: "row" }} gap={2}>
                        <AcxMainTextField
                            id="approval-signature-name"
                            labelText="Approved by"
                            placeholderText="Type your full name"
                            value={props.approverName}
                            onChange={(event) =>
                                props.onApproverNameChange(event.target.value)
                            }
                            fullWidth
                            containerStyle={{ flex: 1 }}
                        />
                        <AcxMainTextField
                            id="approval-signature-date"
                            labelText="Date approved"
                            value={moment().format("MMM D, YYYY · HH:mm")}
                            isDisabled
                            fullWidth
                            containerStyle={{ flex: 1 }}
                        />
                    </Stack>
                    <Alert
                        severity="info"
                        icon={
                            <HistoryEduOutlined
                                fontSize="small"
                                sx={{ color: contextAlertIconColor("info") }}
                            />
                        }
                        sx={(theme) => ({
                            ...contextAlertSx(theme, "info"),
                            "& .MuiAlert-message": {
                                fontSize: "13px",
                            },
                        })}
                    >
                        This is an electronic signature. Name and timestamp are
                        written to the locked change record.
                    </Alert>
                </Stack>
            }
        >
            <Stack direction="row" justifyContent="space-between" width="100%">
                <Stack direction="row" gap={1}>
                    <AcxButton
                        color="error"
                        variant="outlined"
                        onClick={props.onReject}
                    >
                        Reject
                    </AcxButton>
                    <AcxButton
                        variant="outlined"
                        onClick={props.onRequestChanges}
                    >
                        Request changes
                    </AcxButton>
                </Stack>
                <Stack direction="row" gap={1}>
                    <AcxButton color="white" onClick={props.onClose}>
                        Cancel
                    </AcxButton>
                    <AcxButton
                        loading={props.isSaving}
                        disabled={!props.canApprove}
                        onClick={props.onApprove}
                    >
                        Approve version
                    </AcxButton>
                </Stack>
            </Stack>
        </AcxDialog>
    );
}
